module.exports = __webpack_public_path__ + "media/images/logos/pikawaka_symbol-f3246d58c0273dfa4c29b81d458ccfff.png";